import { registerBlockType } from '@wordpress/blocks';
import { useBlockProps, InnerBlocks } from '@wordpress/block-editor';
import json from './block.json';
import Icon from '../images/icons';
const { name } = json;

registerBlockType(name, {
  icon: Icon.ungatedContent,
  edit: () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const blockProps = useBlockProps();
    return (
      <div {...blockProps}>
        <InnerBlocks
          renderAppender={() => <InnerBlocks.ButtonBlockAppender />}
          templateLock={false}
        />
      </div>
    );
  },

  save: () => {
    return <InnerBlocks.Content />;
  },
});
